var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-questions list"},[_c('PageHeader',{attrs:{"title":`Actualités NosDroits`,"description":`Choix des actualités issues de la base commune NosDroits`}}),_c('NewsSubmenu'),_c('PageContent',[_c('MVPTable',{attrs:{"gridData":_vm.gridData,"options":_vm.gridOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }